export default "__VITE_ASSET__BHh9j5_0__"